import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MongodbService } from '../../service';

export type RequireMfaConfig = typeof RequireMfaConfig._.Config;

export const RequireMfaConfig = IntegrationConfig.make({
  service: MongodbService,
  name: Integration_Handler_Names_Enum.RequireMfa,
  configSchema: z.object({}),
});
